export default {
    namespaced: true,
    state: {
        text: "",
    },
    mutations: {
        SHOW_ERROR(state, payload) {
            state.text = payload;
        },
        SHOW_SUCCESS(state, payload) {
            state.text = payload;
        },
        SHOW_INFO(state, payload) {
            state.text = payload;
        },
    },
    actions: {
        showError({ commit }, payload) {
            commit("SHOW_ERROR", payload);
        },
        showInfo({ commit }, payload) {
            commit("SHOW_INFO", payload);
        },
        showSuccess({ commit }, payload) {
            commit("SHOW_SUCCESS", payload);
        },
    },
};